
















import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { TranslateResult } from 'vue-i18n'
import { mapGetters } from 'vuex'
import { Profile, Deal } from '@/requests/mainApi'
import CompleteDealButton from '@/components/modules/App/Profile/CompleteDealButton.vue'
import { IProfileStatus } from '@/store/interfaces'

interface Data {}

interface Methods {}

interface Computed {
  computeHello: TranslateResult
  userData: Profile
  profileIsCompleted: boolean
  profileStatus: IProfileStatus
  deal: Deal
}
interface Props {}

export default Vue.extend({
  name: 'HelloBlock',
  components: {
    CompleteDealButton
  },
  computed: {
    computeHello () {
      if (this.userData.firstName) {
        return this.$t('app.profile.helloTextWithName', this.userData)
      }

      return this.$t('app.profile.helloText')
    },
    profileStatus () {
      if (this.deal && this.deal.stage) return 'dealIsCreated'

      if (!this.profileIsCompleted) return 'profileIsEmpty'

      if (this.userData.docsIsUploaded && !this.userData.isVerified) return 'docsIsUploaded'

      if (this.userData.isVerified) return 'isVerified'

      return 'docsIsNotUploaded'
    },
    computeAnnotation () {
      return this.deal.stage
    },
    ...mapGetters(['userData', 'profileIsCompleted', 'isNoActionStage', 'deal'])
  },
  methods: {
    computeTranslate (position: string) {
      if (this.deal && position === 'text' && this.profileStatus === 'dealIsCreated') {
        switch (this.deal.stage) {
          case 'load_owners':
            return this.$t('app.profile.recommendationDealTexts.type_of_ownership')
          case 'send_deal_data':
            return this.$t('app.profile.recommendationDealTexts.send_deal_data')
          case 'load_pay_data':
            return this.$t('app.profile.recommendationDealTexts.pay_options')
          case 'final':
            return this.$t('app.profile.recommendationDealTexts.pay_under_contract')
          default:
            return this.$t(`app.profile.recommendationDealTexts.${this.deal.stage}`)
        }
      }
      return this.$t(`app.profile.${position}.${this.profileStatus}`)
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
